"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.geoKeys = exports.geoKeyNames = exports.LercAddCompression = exports.LercParameters = exports.ExtraSamplesValues = exports.photometricInterpretations = exports.fieldTypes = exports.fieldTypeNames = exports.arrayFields = exports.fieldTagTypes = exports.fieldTags = exports.fieldTagNames = void 0;
exports.fieldTagNames = {
  // TIFF Baseline
  0x013B: 'Artist',
  0x0102: 'BitsPerSample',
  0x0109: 'CellLength',
  0x0108: 'CellWidth',
  0x0140: 'ColorMap',
  0x0103: 'Compression',
  0x8298: 'Copyright',
  0x0132: 'DateTime',
  0x0152: 'ExtraSamples',
  0x010A: 'FillOrder',
  0x0121: 'FreeByteCounts',
  0x0120: 'FreeOffsets',
  0x0123: 'GrayResponseCurve',
  0x0122: 'GrayResponseUnit',
  0x013C: 'HostComputer',
  0x010E: 'ImageDescription',
  0x0101: 'ImageLength',
  0x0100: 'ImageWidth',
  0x010F: 'Make',
  0x0119: 'MaxSampleValue',
  0x0118: 'MinSampleValue',
  0x0110: 'Model',
  0x00FE: 'NewSubfileType',
  0x0112: 'Orientation',
  0x0106: 'PhotometricInterpretation',
  0x011C: 'PlanarConfiguration',
  0x0128: 'ResolutionUnit',
  0x0116: 'RowsPerStrip',
  0x0115: 'SamplesPerPixel',
  0x0131: 'Software',
  0x0117: 'StripByteCounts',
  0x0111: 'StripOffsets',
  0x00FF: 'SubfileType',
  0x0107: 'Threshholding',
  0x011A: 'XResolution',
  0x011B: 'YResolution',
  // TIFF Extended
  0x0146: 'BadFaxLines',
  0x0147: 'CleanFaxData',
  0x0157: 'ClipPath',
  0x0148: 'ConsecutiveBadFaxLines',
  0x01B1: 'Decode',
  0x01B2: 'DefaultImageColor',
  0x010D: 'DocumentName',
  0x0150: 'DotRange',
  0x0141: 'HalftoneHints',
  0x015A: 'Indexed',
  0x015B: 'JPEGTables',
  0x011D: 'PageName',
  0x0129: 'PageNumber',
  0x013D: 'Predictor',
  0x013F: 'PrimaryChromaticities',
  0x0214: 'ReferenceBlackWhite',
  0x0153: 'SampleFormat',
  0x0154: 'SMinSampleValue',
  0x0155: 'SMaxSampleValue',
  0x022F: 'StripRowCounts',
  0x014A: 'SubIFDs',
  0x0124: 'T4Options',
  0x0125: 'T6Options',
  0x0145: 'TileByteCounts',
  0x0143: 'TileLength',
  0x0144: 'TileOffsets',
  0x0142: 'TileWidth',
  0x012D: 'TransferFunction',
  0x013E: 'WhitePoint',
  0x0158: 'XClipPathUnits',
  0x011E: 'XPosition',
  0x0211: 'YCbCrCoefficients',
  0x0213: 'YCbCrPositioning',
  0x0212: 'YCbCrSubSampling',
  0x0159: 'YClipPathUnits',
  0x011F: 'YPosition',
  // EXIF
  0x9202: 'ApertureValue',
  0xA001: 'ColorSpace',
  0x9004: 'DateTimeDigitized',
  0x9003: 'DateTimeOriginal',
  0x8769: 'Exif IFD',
  0x9000: 'ExifVersion',
  0x829A: 'ExposureTime',
  0xA300: 'FileSource',
  0x9209: 'Flash',
  0xA000: 'FlashpixVersion',
  0x829D: 'FNumber',
  0xA420: 'ImageUniqueID',
  0x9208: 'LightSource',
  0x927C: 'MakerNote',
  0x9201: 'ShutterSpeedValue',
  0x9286: 'UserComment',
  // IPTC
  0x83BB: 'IPTC',
  // ICC
  0x8773: 'ICC Profile',
  // XMP
  0x02BC: 'XMP',
  // GDAL
  0xA480: 'GDAL_METADATA',
  0xA481: 'GDAL_NODATA',
  // Photoshop
  0x8649: 'Photoshop',
  // GeoTiff
  0x830E: 'ModelPixelScale',
  0x8482: 'ModelTiepoint',
  0x85D8: 'ModelTransformation',
  0x87AF: 'GeoKeyDirectory',
  0x87B0: 'GeoDoubleParams',
  0x87B1: 'GeoAsciiParams',
  // LERC
  0xC5F2: 'LercParameters'
};
exports.fieldTags = {};

for (var key in exports.fieldTagNames) {
  if (exports.fieldTagNames.hasOwnProperty(key)) {
    exports.fieldTags[exports.fieldTagNames[key]] = parseInt(key, 10);
  }
}

exports.fieldTagTypes = {
  256: 'SHORT',
  257: 'SHORT',
  258: 'SHORT',
  259: 'SHORT',
  262: 'SHORT',
  273: 'LONG',
  274: 'SHORT',
  277: 'SHORT',
  278: 'LONG',
  279: 'LONG',
  282: 'RATIONAL',
  283: 'RATIONAL',
  284: 'SHORT',
  286: 'SHORT',
  287: 'RATIONAL',
  296: 'SHORT',
  297: 'SHORT',
  305: 'ASCII',
  306: 'ASCII',
  338: 'SHORT',
  339: 'SHORT',
  513: 'LONG',
  514: 'LONG',
  1024: 'SHORT',
  1025: 'SHORT',
  2048: 'SHORT',
  2049: 'ASCII',
  3072: 'SHORT',
  3073: 'ASCII',
  33550: 'DOUBLE',
  33922: 'DOUBLE',
  34665: 'LONG',
  34735: 'SHORT',
  34737: 'ASCII',
  42113: 'ASCII'
};
exports.arrayFields = [exports.fieldTags.BitsPerSample, exports.fieldTags.ExtraSamples, exports.fieldTags.SampleFormat, exports.fieldTags.StripByteCounts, exports.fieldTags.StripOffsets, exports.fieldTags.StripRowCounts, exports.fieldTags.TileByteCounts, exports.fieldTags.TileOffsets, exports.fieldTags.SubIFDs];
exports.fieldTypeNames = {
  0x0001: 'BYTE',
  0x0002: 'ASCII',
  0x0003: 'SHORT',
  0x0004: 'LONG',
  0x0005: 'RATIONAL',
  0x0006: 'SBYTE',
  0x0007: 'UNDEFINED',
  0x0008: 'SSHORT',
  0x0009: 'SLONG',
  0x000A: 'SRATIONAL',
  0x000B: 'FLOAT',
  0x000C: 'DOUBLE',
  // IFD offset, suggested by https://owl.phy.queensu.ca/~phil/exiftool/standards.html
  0x000D: 'IFD',
  // introduced by BigTIFF
  0x0010: 'LONG8',
  0x0011: 'SLONG8',
  0x0012: 'IFD8'
};
exports.fieldTypes = {};

for (var _key in exports.fieldTypeNames) {
  if (exports.fieldTypeNames.hasOwnProperty(_key)) {
    exports.fieldTypes[exports.fieldTypeNames[_key]] = parseInt(_key, 10);
  }
}

exports.photometricInterpretations = {
  WhiteIsZero: 0,
  BlackIsZero: 1,
  RGB: 2,
  Palette: 3,
  TransparencyMask: 4,
  CMYK: 5,
  YCbCr: 6,
  CIELab: 8,
  ICCLab: 9
};
exports.ExtraSamplesValues = {
  Unspecified: 0,
  Assocalpha: 1,
  Unassalpha: 2
};
exports.LercParameters = {
  Version: 0,
  AddCompression: 1
};
exports.LercAddCompression = {
  None: 0,
  Deflate: 1
};
exports.geoKeyNames = {
  1024: 'GTModelTypeGeoKey',
  1025: 'GTRasterTypeGeoKey',
  1026: 'GTCitationGeoKey',
  2048: 'GeographicTypeGeoKey',
  2049: 'GeogCitationGeoKey',
  2050: 'GeogGeodeticDatumGeoKey',
  2051: 'GeogPrimeMeridianGeoKey',
  2052: 'GeogLinearUnitsGeoKey',
  2053: 'GeogLinearUnitSizeGeoKey',
  2054: 'GeogAngularUnitsGeoKey',
  2055: 'GeogAngularUnitSizeGeoKey',
  2056: 'GeogEllipsoidGeoKey',
  2057: 'GeogSemiMajorAxisGeoKey',
  2058: 'GeogSemiMinorAxisGeoKey',
  2059: 'GeogInvFlatteningGeoKey',
  2060: 'GeogAzimuthUnitsGeoKey',
  2061: 'GeogPrimeMeridianLongGeoKey',
  2062: 'GeogTOWGS84GeoKey',
  3072: 'ProjectedCSTypeGeoKey',
  3073: 'PCSCitationGeoKey',
  3074: 'ProjectionGeoKey',
  3075: 'ProjCoordTransGeoKey',
  3076: 'ProjLinearUnitsGeoKey',
  3077: 'ProjLinearUnitSizeGeoKey',
  3078: 'ProjStdParallel1GeoKey',
  3079: 'ProjStdParallel2GeoKey',
  3080: 'ProjNatOriginLongGeoKey',
  3081: 'ProjNatOriginLatGeoKey',
  3082: 'ProjFalseEastingGeoKey',
  3083: 'ProjFalseNorthingGeoKey',
  3084: 'ProjFalseOriginLongGeoKey',
  3085: 'ProjFalseOriginLatGeoKey',
  3086: 'ProjFalseOriginEastingGeoKey',
  3087: 'ProjFalseOriginNorthingGeoKey',
  3088: 'ProjCenterLongGeoKey',
  3089: 'ProjCenterLatGeoKey',
  3090: 'ProjCenterEastingGeoKey',
  3091: 'ProjCenterNorthingGeoKey',
  3092: 'ProjScaleAtNatOriginGeoKey',
  3093: 'ProjScaleAtCenterGeoKey',
  3094: 'ProjAzimuthAngleGeoKey',
  3095: 'ProjStraightVertPoleLongGeoKey',
  3096: 'ProjRectifiedGridAngleGeoKey',
  4096: 'VerticalCSTypeGeoKey',
  4097: 'VerticalCitationGeoKey',
  4098: 'VerticalDatumGeoKey',
  4099: 'VerticalUnitsGeoKey'
};
exports.geoKeys = {};

for (var _key2 in exports.geoKeyNames) {
  if (exports.geoKeyNames.hasOwnProperty(_key2)) {
    exports.geoKeys[exports.geoKeyNames[_key2]] = parseInt(_key2, 10);
  }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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